import { useNavigate } from 'react-router-dom';
import OrderList from '../../components/orders/OrderList';
import useOrders from '../../hooks/useOrders';
import './Orders.css';

const Orders = () => {
  const navigate = useNavigate();
  const { orders, loading, error, refresh } = useOrders();

  return (
    <div className="orders-page">
      <div className="orders-page__header">
        <div className="orders-page__header-left">
          <p className="orders-page__eyebrow">Deep Roots Milling</p>
          <h1 className="orders-page__title">Order History</h1>
        </div>
        <div className="orders-page__actions">
          <button
            className="orders-page__refresh"
            onClick={refresh}
            disabled={loading}
          >
            {loading ? 'Refreshing…' : '↺ Refresh'}
          </button>
          <button
            className="orders-page__new-order"
            onClick={() => navigate('/products')}
          >
            New Order →
          </button>
        </div>
      </div>

      <hr className="orders-page__rule" />

      <div className="orders-page__content">
        <OrderList
          orders={orders}
          loading={loading}
          error={error}
          isEmployee={false}
        />
      </div>
    </div>
  );
};

export default Orders;
